import { render } from "./HowToOtpAuth.vue?vue&type=template&id=41aef228&scoped=true"
import script from "./HowToOtpAuth.vue?vue&type=script&lang=js"
export * from "./HowToOtpAuth.vue?vue&type=script&lang=js"

import "./HowToOtpAuth.vue?vue&type=style&index=0&id=41aef228&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41aef228"]])

export default __exports__